export default function initCtaForm() {
    const cta = document.querySelectorAll(".cta");
    const ctaSingle = document.querySelector('.cta-single');

    if (cta && cta.length) {
        cta.forEach((item) => {
            formInitHandler(item);
        });
    } else if (ctaSingle) {
        formInitHandler(ctaSingle);
    }

    function formInitHandler(item) {
        const inputs = item.querySelectorAll('input.wpcf7-form-control');
        const radios = item.querySelectorAll('.wpcf7-list-item input');
        const textarea = item.querySelector('.wpcf7-form-control.wpcf7-textarea');
        const submit = item.querySelector('.wpcf7-form-control.wpcf7-submit');
        const submitCallBack = item.querySelector('.submit-email .wpcf7-submit');

        let valuObjCallBack = {
            tel: false,
            time: false,
        }

        let valuObjEmail = {
            email: false,
            textarea: false,
        }

        function checkValueCallBack() {
            Object.values(valuObjCallBack).every(value => value === true) ? submit.classList.add('active') : submit.classList.remove('active');
        }

        function checkValueEmail() {
            Object.values(valuObjEmail).every(value => value === true) ? submitCallBack.classList.add('active') : submitCallBack.classList.remove('active');
        }

        inputs.forEach(input => {
            input.addEventListener('input', function () {
                valuObjCallBack.tel = (input.value && input.hasAttribute('type', 'tel')) ? true : false;
                valuObjEmail.email = (input.value && input.hasAttribute('type', 'email')) ? true : false;
                checkValueCallBack();
                checkValueEmail();
            })
        })

        radios.forEach(radio => {
            radio.addEventListener('click', function () {
                valuObjCallBack.time = true;
                checkValueCallBack();
            })
        })

        textarea.addEventListener('input', function () {
            valuObjEmail.textarea = textarea.value ? true : false;
            checkValueEmail();
        })
    }
}
